/* @flow */

import { rem } from 'polished';

import { baseFontSize } from '@braindate/ui/lib/token/typography';

export default {
  root: {
    margin: [rem(12, baseFontSize), 0, rem(8, baseFontSize)],

    textAlign: 'center',
  },
};
